import React from 'react';
import './PolicyPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-header">
          <h1>Privacy Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="policy-content">
          <section>
            <h2>1. Information We Collect</h2>
            <p>We collect personal information including name, email address, phone number, shipping address, and payment information when you create an account or place an order. We also collect prescription details for eyewear orders.</p>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to process orders, provide customer support, improve our services, send order updates, and communicate promotional offers (with your consent).</p>
          </section>

          <section>
            <h2>3. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share information with shipping partners, payment processors, and as required by law.</p>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>We implement industry-standard security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.</p>
          </section>

          <section>
            <h2>5. Cookies</h2>
            <p>We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. You can disable cookies in your browser settings.</p>
          </section>

          <section>
            <h2>6. Third-Party Links</h2>
            <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites.</p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>You have the right to access, update, or delete your personal information. You can do this through your account settings or by contacting us directly.</p>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>Our website is not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>
          </section>

          <section>
            <h2>9. Changes to Privacy Policy</h2>
            <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at:<br />
            Email: kadharvco@gmail.com<br />
            Phone: +91 94436 53501<br />
            Address: 7/7 Balusamy Street, Opp to IOB, Palavanthangal, Chennai - 600114</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;